/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Assistant_Messages_LeftInputs */



/**
* | output |
* | --- |
* | "Messages left today: {count}" |
*
* @param {Assistant_Messages_LeftInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_messages_left = /** @type {((inputs: Assistant_Messages_LeftInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Messages_LeftInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Messages laissés aujourd'hui : ${i?.count}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Heute hinterlassene Nachrichten: ${i?.count}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Messaggi lasciati oggi: ${i?.count}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Сообщения, оставленные сегодня: ${i?.count}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Mensajes recibidos hoy: ${i?.count}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`今天留下的留言：${i?.count}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`本日残されたメッセージ: ${i?.count}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`आज छोड़े गए संदेश: ${i?.count}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Mensagens deixadas hoje: ${i?.count}`)
	return /** @type {LocalizedString} */ (`Messages left today: ${i?.count}`)
});